import React, { useEffect, useState } from 'react';
import { gql, useQuery } from "@apollo/client";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer, 
  LabelList
} from "recharts";

const GET_PEDIDOS = gql`
  query getPedidos {
    getPedidos {
      _id
      fecha
      productos
    }
  }
`;

function VendidosEstadisticas() {
  const { loading, error, data } = useQuery(GET_PEDIDOS);
 const [filtroInput, setFiltroInput] = useState("");
const [filtroBuscar, setFiltroBuscar] = useState(""); // <-- SOLO filtra al presionar ENTER


  const [dias, setDias] = useState([]);
  const [semanas, setSemanas] = useState([]);
  const [meses, setMeses] = useState([]);

  const obtenerSemanaDelMes = (fecha) => {
    return Math.ceil((fecha.getDate()) / 7);
  };

 const procesarEstadisticas = () => {
  if (!data?.getPedidos) return;

  const productoBuscado = filtroBuscar.trim().toLowerCase();
  if (productoBuscado === "") return;

  const mapaDias = {};
  const mapaSemanas = {};
  const mapaMeses = {};

  const hoy = new Date();
  hoy.setHours(0,0,0,0);

  const hace7dias = new Date(hoy);
  hace7dias.setDate(hoy.getDate() - 6);

  const hace30dias = new Date(hoy);
  hace30dias.setDate(hoy.getDate() - 30);

  const hace12meses = new Date(hoy);
  hace12meses.setMonth(hoy.getMonth() - 12);


  data.getPedidos.forEach(pedido => {
    const fecha = new Date(pedido.fecha);
    fecha.setHours(fecha.getHours() - 5);

    const productos = JSON.parse(pedido.productos || "[]");

    productos.forEach(p => {
      const nombre = p.nombre.toLowerCase();
      if (!nombre.includes(productoBuscado)) return;

      let cantidadVendida = p.cantidad;

      // --- FILTRO 7 DÍAS ---
      if (fecha >= hace7dias) {
        const diaSemana = fecha.toLocaleDateString("es-CO", { weekday: "short" });
        mapaDias[diaSemana] = (mapaDias[diaSemana] || 0) + cantidadVendida;
      }

      // --- FILTRO 4 SEMANAS (30 días) ---
      if (fecha >= hace30dias) {
        const semana = Math.ceil(fecha.getDate() / 7);
        mapaSemanas[`Semana ${semana}`] =
          (mapaSemanas[`Semana ${semana}`] || 0) + cantidadVendida;
      }

      // --- FILTRO 12 MESES ---
      if (fecha >= hace12meses) {
        const mes = fecha.toLocaleDateString("es-CO", { month: "short" });
        mapaMeses[mes] = (mapaMeses[mes] || 0) + cantidadVendida;
      }

    });
  });

  setDias(Object.entries(mapaDias).map(([dia, cantidad]) => ({ dia, cantidad })));
  setSemanas(Object.entries(mapaSemanas).map(([semana, cantidad]) => ({ semana, cantidad })));
  setMeses(Object.entries(mapaMeses).map(([mes, cantidad]) => ({ mes, cantidad })));
};


  useEffect(() => {
    procesarEstadisticas();
  }, [data, filtroBuscar]);

  if (loading) return <p>Cargando...</p>;
  if (error) return <p>Error: {error.message}</p>;

  return (
    <div>

      <h2>Estadísticas de ventas por producto</h2>

      <input
  type="text"
  placeholder="Buscar producto..."
  value={filtroInput}
  onChange={(e) => setFiltroInput(e.target.value)}
  onKeyDown={(e) => {
    if (e.key === "Enter") {
      setFiltroBuscar(filtroInput.trim().toLowerCase());
    }
  }}
  style={{ padding: 8, marginBottom: 20 }}
/>


      {filtroBuscar.trim() !== "" && (
        <>
          {/* --- GRAFICA 7 DÍAS --- */}
          <h3>Ventas por día (7 días)</h3>
          {data.dias}
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={dias}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="dia" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar dataKey="cantidad" name="Total vendido" fill="#183285af" >
                 <LabelList dataKey="cantidad" position="top" color='black' />
                </Bar>
            </BarChart>
          </ResponsiveContainer>

          {/* --- GRAFICA 4 SEMANAS DEL MES --- */}
          <h3>Ventas por semana (4 semanas del mes)</h3>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={semanas}>
              <CartesianGrid strokeDasharray="4 1" />
              <XAxis dataKey="semana" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar dataKey="cantidad" name="Total vendido" fill="#1a862e80" >
                  <LabelList dataKey="cantidad" position="top" color='black' />
                </Bar>
            </BarChart>
          </ResponsiveContainer>

          {/* --- GRAFICA 12 MESES --- */}
          <h3>Ventas por mes (12 meses)</h3>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={meses}>
              <CartesianGrid strokeDasharray="3 1" />
              <XAxis dataKey="mes" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar dataKey="cantidad" name="Total vendido" fill="#b97f09ab" >
                  <LabelList dataKey="cantidad" position="top" color='black' />
                </Bar>
            </BarChart>
          </ResponsiveContainer>
        </>
      )}
    </div>
  );
}

export default VendidosEstadisticas;
